<template>
  <div class="course-schedule-manage-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>日程查询</span>
          </div>
          <el-form
            :inline="true"
            :model="searchForm"
            class="search-form text-left"
          >
            <el-form-item>
              <el-date-picker
                v-model="searchForm.courseDate"
                type="date"
                placeholder="请选择日期"
                clearable
                style="width: 180px"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="searchForm.section"
                placeholder="请选择时段"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in sectionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchForm.courseName"
                placeholder="请输入会议名称"
                clearable
                style="width: 200px"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchForm.participants"
                placeholder="请输入参会人员"
                clearable
                style="width: 200px"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch"> 查询 </el-button>
              <el-button @click="handleReset"> 重置 </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>日程维护列表</span>
            <div>
              <el-button
                type="primary"
                size="small"
                @click="handleAdd"
                icon="el-icon-plus"
              >
                新增
              </el-button>
            </div>
          </div>
          <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%"
            stripe
          >
            <el-table-column
              prop="courseDate"
              label="日期"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="section"
              label="时段"
              align="center"
              min-width="200"
            >
              <template slot-scope="scope">
                <el-tag
                  v-for="sec in scope.row.section.split(',')"
                  :key="sec"
                  size="mini"
                  style="margin: 2px"
                >
                  {{ formatSectionLabel(sec) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="courseName"
              label="会议名称"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="room"
              label="会议地点"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              prop="participants"
              label="参会人员"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              align="center"
              min-width="200"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="日程颜色" align="center" width="120">
              <template slot-scope="scope">
                <div
                  class="color-block"
                  :style="{
                    backgroundColor: scope.row.courseColor || '#e0e0e0',
                  }"
                ></div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px; text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="form.id ? '编辑日程' : '新增日程'"
      :visible.sync="formVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="日期" prop="courseDate">
          <el-date-picker
            v-model="form.courseDate"
            type="date"
            placeholder="请选择日期"
            style="width: 100%"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="时段" prop="section">
          <el-select
            v-model="form.section"
            placeholder="请选择时段（可多选）"
            multiple
            collapse-tags
            style="width: 100%"
          >
            <el-option
              v-for="item in sectionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议名称" prop="courseName">
          <el-input
            v-model="form.courseName"
            placeholder="请输入会议名称"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="会议地点" prop="room">
          <el-input
            v-model="form.room"
            placeholder="请输入会议地点"
            maxlength="50"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="参会人员" prop="participants">
          <el-input
            v-model="form.participants"
            placeholder="请输入参会人员"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            placeholder="请输入备注信息（选填）"
            type="textarea"
            rows="3"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="附件" :prop="!viewMode ? 'attachments' : ''">
          <div v-if="viewMode" class="view-attachment">
            <el-link
              v-if="form.url"
              :href="form.url"
              target="_blank"
              icon="el-icon-download"
              @click.stop="downloadAttachment(form)"
            >
              {{ form.fileName || getFileName(form.url) || "会议附件" }}
            </el-link>
            <span v-else> 无附件 </span>
          </div>

          <div v-else class="edit-attachment">
            <el-upload
              class="upload-demo"
              drag
              action="/callComponent/upload/uploadFile/uploadImage"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
              :limit="1"
              name="uploadFile"
              :data="uploadExtraParams"
              :file-list="fileList"
              :on-success="handleUploadSuccess"
              :on-remove="handleRemove"
              :auto-upload="true"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                支持 PDF, Word, Excel, PPT (单个文件最大 10MB)
              </div>
            </el-upload>
            <div
              v-if="form.originalUrl && fileList.length === 0"
              class="original-attachment mt-2"
            >
              <span class="label"> 原附件：</span>
              <el-link
                :href="form.originalUrl"
                target="_blank"
                icon="el-icon-download"
                class="ml-1"
                @click.stop="
                  downloadAttachment({
                    url: form.originalUrl,
                    fileName: form.originalFileName,
                  })
                "
              >
                {{
                  form.originalFileName ||
                  getFileName(form.originalUrl) ||
                  "会议附件"
                }}
              </el-link>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="日程颜色" prop="courseColor">
          <el-color-picker
            v-model="form.courseColor"
            :predefine="predefineColors"
            placeholder="选择日程展示颜色"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="删除日程"
      :visible.sync="deleteVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 0; text-align: center">
        <i class="el-icon-warning" style="color: #e6a23c; font-size: 24px"></i>
        <p style="margin-top: 10px">确定要删除该日程吗？</p>
        <p style="color: #999; font-size: 12px">删除后将无法恢复，请谨慎操作</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">确定删除</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCourseScheduleList,
  addCourseSchedule,
  editCourseSchedule,
  deleteCourseSchedule,
} from "@/api/contract/courseScheduleApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "CourseScheduleManage",
  data() {
    return {
      loading: false,
      searchForm: {
        courseDate: "",
        section: "",
        courseName: "",
        participants: "",
      },
      // 时段：8:00~17:00 每小时一段
      sectionOptions: [
        { label: "08:00-09:00", value: "480" },
        { label: "09:00-10:00", value: "540" },
        { label: "10:00-11:00", value: "600" },
        { label: "11:00-12:00", value: "660" },
        { label: "12:00-13:00", value: "720" },
        { label: "13:00-14:00", value: "780" },
        { label: "14:00-15:00", value: "840" },
        { label: "15:00-16:00", value: "900" },
        { label: "16:00-17:00", value: "960" },
      ],
      predefineColors: [
        "#9c88d8",
        "#a0846c",
        "#d4d1e8",
        "#88a67e",
        "#a09b8c",
        "#b9e0d1",
        "#d4e0d1",
        "#b9b1d1",
        "#a0c4a8",
        "#88a69e",
        "#e0d8b9",
      ],
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      formVisible: false,
      viewMode: false,
      form: {
        id: "",
        courseDate: "",
        section: [],
        courseName: "",
        room: "",
        participants: "",
        remark: "",
        courseColor: "#e0e0e0",
        communityId: "",
        isDeleted: "0",
        sectionTime: "",
        url: "",
        fileName: "",
        originalUrl: "",
        originalFileName: "",
      },
      fileList: [],
      uploadExtraParams: {
        businessType: "courseSchedule",
        communityId: "",
      },
      rules: {
        courseDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        section: [
          { required: true, message: "请选择至少一个时段", trigger: "change" },
          {
            type: "array",
            min: 1,
            message: "请选择至少一个时段",
            trigger: "change",
          },
        ],
        courseName: [
          { required: true, message: "请输入会议名称", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "会议名称长度在1-100个字符",
            trigger: "blur",
          },
        ],
        room: [
          { required: true, message: "请输入会议地点", trigger: "blur" },
          { max: 50, message: "会议地点长度不超过50个字符", trigger: "blur" },
        ],
        participants: [
          { required: true, message: "请输入参会人员", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "参会人员长度在1-200个字符",
            trigger: "blur",
          },
        ],
        remark: [
          {
            max: 500,
            message: "备注长度不超过500个字符",
            trigger: "blur",
          },
        ],
        attachments: [],
      },
      deleteVisible: false,
      deleteRow: {},
      communityId: "",
    };
  },
  created() {
    this.communityId = getCommunityId() || "";
    this.form.communityId = this.communityId;
    this.uploadExtraParams.communityId = this.communityId;
    this.getList();
  },
  methods: {
    getFileName(url) {
      if (!url) return "";
      const fileName = url.split("/").pop().split("?")[0];
      try {
        return decodeURIComponent(fileName);
      } catch (e) {
        return fileName;
      }
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          page: this.page.current,
          row: this.page.size,
          courseDate: this.searchForm.courseDate,
          section: this.searchForm.section,
          courseName: this.searchForm.courseName,
          participants: this.searchForm.participants,
          communityId: this.communityId,
        };
        const res = await getCourseScheduleList(params);
        if (res && res.code === 0) {
          this.tableData = res.data || [];
          this.page.total = res.total || 0;
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error(res.msg || "获取日程失败");
        }
      } catch (error) {
        console.error("获取日程列表失败:", error);
        this.$message.error("获取日程列表失败，请稍后重试");
        this.tableData = [];
        this.page.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },
    handleReset() {
      this.searchForm = {
        courseDate: "",
        section: "",
        courseName: "",
        participants: "",
      };
      this.handleSearch();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    formatSectionLabel(sectionValue) {
      const sectionItem = this.sectionOptions.find(
        (item) => item.value === sectionValue,
      );
      return sectionItem ? sectionItem.label : sectionValue;
    },
    handleAdd() {
      this.viewMode = false;
      this.form = {
        id: "",
        courseDate: "",
        section: [],
        courseName: "",
        room: "",
        participants: "",
        remark: "",
        courseColor: "#e0e0e0",
        communityId: this.communityId,
        isDeleted: "0",
        sectionTime: "",
        url: "",
        fileName: "",
        originalUrl: "",
        originalFileName: "",
      };
      this.fileList = [];
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    handleEdit(row) {
      this.viewMode = false;
      const sectionArray = row.section ? row.section.split(",") : [];
      this.form = {
        ...row,
        section: sectionArray,
        participants: row.participants || "",
        remark: row.remark || "",
        url: "",
        fileName: "",
        originalUrl: row.url || "",
        originalFileName: row.fileName || "",
        communityId: this.communityId,
        isDeleted: row.isDeleted || "0",
        sectionTime: row.sectionTime || "",
      };
      this.fileList = [];
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    handleUploadSuccess(response, file) {
      if (response.url) {
        this.form.url = response.url;
        this.form.fileName = file.name;
        this.fileList = [file];
        this.$message.success("文件上传成功");
      } else {
        this.$message.error("文件上传失败：未获取到文件地址");
      }
    },
    handleRemove(file, fileList) {
      this.form.url = "";
      this.form.fileName = "";
      this.fileList = fileList;
    },
    downloadAttachment(row) {
      if (!row.url) {
        this.$message.warning("暂无附件可下载");
        return;
      }
      try {
        const link = document.createElement("a");
        link.href = row.url;
        const downName =
          row.fileName || this.getFileName(row.url) || "会议附件";
        link.download = downName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("下载附件失败：", error);
        this.$message.error("附件下载失败，请稍后重试");
      }
    },
    async handleSubmit() {
      try {
        const validateResult = await this.$refs.formRef.validate();
        if (!validateResult) {
          return;
        }
        const submitForm = {
          ...this.form,
          communityId: this.communityId,
          section: this.form.section.join(","),
          participants: this.form.participants,
          remark: this.form.remark,
          url: this.form.url || this.form.originalUrl,
          fileName: this.form.url
            ? this.form.fileName
            : this.form.originalFileName,
          isDeleted: this.form.isDeleted || "0",
          sectionTime: this.form.sectionTime || "",
          courseColor: this.form.courseColor || "#e0e0e0",
        };
        let res;
        if (submitForm.id) {
          res = await editCourseSchedule(submitForm);
        } else {
          res = await addCourseSchedule(submitForm);
        }
        if (res && res.code === 0) {
          this.$message.success(
            submitForm.id ? "编辑日程成功" : "新增日程成功",
          );
          this.formVisible = false;
          this.getList();
        } else {
          this.$message.error(
            res.msg || (submitForm.id ? "编辑日程失败" : "新增日程失败"),
          );
        }
      } catch (error) {
        if (error !== false) {
          console.error("提交日程失败:", error);
        }
      }
    },
    handleDelete(row) {
      this.deleteRow = row;
      this.deleteVisible = true;
    },
    async confirmDelete() {
      try {
        const res = await deleteCourseSchedule({
          id: this.deleteRow.id,
          communityId: this.communityId,
        });
        if (res && res.code === 0) {
          this.$message.success("删除日程成功");
          this.deleteVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg || "删除日程失败");
        }
      } catch (error) {
        console.error("删除日程失败:", error);
        this.$message.error("删除日程失败，请稍后重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.course-schedule-manage-container {
  padding: 20px;

  .search-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-card {
    margin-bottom: 20px;
  }

  .dialog-footer {
    text-align: right;
  }

  .color-block {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: inline-block;
    border: 1px solid #eee;
    margin: 0 auto;
  }

  ::v-deep .el-table th {
    background-color: #f8f9fa;
  }

  ::v-deep .el-table--striped .el-table__row--striped td {
    background-color: #fafafa;
  }

  ::v-deep .el-form-item__content {
    line-height: 1.2;
  }

  ::v-deep .el-tag {
    margin-bottom: 4px;
  }

  ::v-deep .upload-demo {
    margin-top: 5px;
  }

  ::v-deep .el-upload-dragger {
    width: 100%;
    height: 180px;
  }

  .view-attachment {
    line-height: 32px;
  }

  .edit-attachment {
    .original-attachment {
      padding: 8px 0;
      .label {
        color: #666;
        font-size: 14px;
      }
      .ml-1 {
        margin-left: 8px;
      }
    }
  }

  .mt-2 {
    margin-top: 8px;
  }
}
</style>
